module.exports = __webpack_public_path__ + "img/tipica-chilena.e4518f6a.jpg";